import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import { Box, Button, Container, Table, TableBody, TableCell, TableHead, TableRow, Pagination } from "@mui/material";
import axios from "axios";
import { useEffect, useState, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { t } from "i18next";
import React from "react";

axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("user");
        if (token) config.headers["Authorization"] = `Bearer ${token}`;
        return config;
    },
    (error) => Promise.reject(error)
);

function HistoryTransfer() {
    const [data, setData] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [searched, setSearched] = useState("");
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const limit = 15;
    const typingTimeoutRef = useRef(null);

    const fetchHistoryTransfer = () => {
        setLoading(true);
        axios
            .get(`${process.env.REACT_APP_API_URL}/casino/history-transfer?page=${page}&limit=${limit}&username=${searched}`)
            .then((res) => {
                if (res.data?.success) {
                    setData(res.data.data.rows || res.data.data || []);
                    if (res.data.data.totalPages) setTotalPages(res.data.data.totalPages);
                } else {
                    setData([]);
                }
                setLoading(false);
            })
            .catch(() => {
                setData([]);
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchHistoryTransfer();
    }, [page, searched]);

    const handleSearchChange = (e) => {
        const value = e.target.value;
        if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
        typingTimeoutRef.current = setTimeout(() => {
            setSearched(value);
            setPage(1);
        }, 500);
    };

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                <Box component="main" sx={{ flexGrow: 1, py: 2 }}>
                    {isLoading && (
                        <div className="loading" style={{ maxWidth: "100%" }}>
                            <div className="loader"></div>
                        </div>
                    )}
                    <Container maxWidth={false}>
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
                            <h3 style={{ margin: 0, fontSize: "20px", fontWeight: 700, color: "#333" }}>Lịch sử chuyển quỹ</h3>
                        </Box>

                        {/* Top Filter Block */}
                        <div className="ax-filter-block" style={{ marginBottom: "20px" }}>
                            <div style={{ display: "flex", gap: "16px", alignItems: "center", flexWrap: "wrap" }}>
                                <div>
                                    <label style={{ fontSize: "12px", display: "block", color: "#666", marginBottom: "4px" }}>Tên người chơi</label>
                                    <input
                                        type="text"
                                        placeholder="Nhập tên người chơi..."
                                        onChange={handleSearchChange}
                                        style={{ height: "38px", padding: "0 12px", borderRadius: "6px", border: "1px solid #ddd", fontSize: "13px", width: "240px" }}
                                    />
                                </div>
                                <button className="ax-btn-search-red" onClick={() => { setPage(1); fetchHistoryTransfer(); }} style={{ marginTop: "18px", height: "38px" }}>
                                    Tìm kiếm
                                </button>
                            </div>
                        </div>

                        {/* Table Block */}
                        <div className="ax-table-wrapper">
                            <Table>
                                <TableHead sx={{ backgroundColor: "#fafafa" }}>
                                    <TableRow>
                                        <TableCell sx={{ padding: "12px 10px", fontWeight: "700" }}>Mã giao dịch</TableCell>
                                        <TableCell sx={{ padding: "12px 10px", fontWeight: "700" }}>Tên người chơi</TableCell>
                                        <TableCell sx={{ padding: "12px 10px", fontWeight: "700" }}>Sảnh</TableCell>
                                        <TableCell sx={{ padding: "12px 10px", fontWeight: "700" }}>Kiểu chuyển</TableCell>
                                        <TableCell sx={{ padding: "12px 10px", fontWeight: "700" }}>Số điểm</TableCell>
                                        <TableCell sx={{ padding: "12px 10px", fontWeight: "700" }}>Trạng thái</TableCell>
                                        <TableCell sx={{ padding: "12px 10px", fontWeight: "700" }}>Mô tả</TableCell>
                                        <TableCell sx={{ padding: "12px 10px", fontWeight: "700" }}>Ngày tạo</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data && data.length > 0 ? (
                                        data.map((item, idx) => (
                                            <TableRow key={item._id || idx}>
                                                <TableCell sx={{ padding: "10px" }}>{item._id}</TableCell>
                                                <TableCell sx={{ padding: "10px", fontWeight: 600 }}>{item.user?.username}</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>{item.detail?.includes('sảnh ') ? item.detail.split('sảnh ')[1] : item.detail}</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>
                                                    <span style={{
                                                        padding: "3px 10px",
                                                        borderRadius: "4px",
                                                        fontSize: "12px",
                                                        fontWeight: 600,
                                                        background: item.type_payment === "CHUYỂN QUỸ RA" ? "#fff7e6" : "#e6f7ff",
                                                        color: item.type_payment === "CHUYỂN QUỸ RA" ? "#fa8c16" : "#1890ff",
                                                        border: item.type_payment === "CHUYỂN QUỸ RA" ? "1px solid #ffd591" : "1px solid #91d5ff"
                                                    }}>
                                                        {item.type_payment === "CHUYỂN QUỸ RA" ? "Rút ra" : "Chuyển vào"}
                                                    </span>
                                                </TableCell>
                                                <TableCell sx={{ padding: "10px", fontWeight: 700 }}>
                                                    <span style={{ color: item.type_payment === "CHUYỂN QUỸ RA" ? "#52c41a" : "#f5222d" }}>
                                                        {(item.money ? Math.floor(item.money / 1000) : 0).toLocaleString("vi-VN")}
                                                    </span>
                                                </TableCell>
                                                <TableCell sx={{ padding: "10px" }}>
                                                    <span style={{ color: "#52c41a", background: "#f6ffed", border: "1px solid #b7eb8f", padding: "2px 8px", borderRadius: "4px", fontSize: "12px" }}>
                                                        {item.status_payment === "Success" ? "Thành công" : item.status_payment}
                                                    </span>
                                                </TableCell>
                                                <TableCell sx={{ padding: "10px", color: "#666" }}>{item.detail}</TableCell>
                                                <TableCell sx={{ padding: "10px" }}>{new Date(item.createdAt).toLocaleString("vi-VN")}</TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={8} align="center" sx={{ py: 4, color: "#888" }}>
                                                📥 Không có dữ liệu chuyển quỹ
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </div>

                        {/* Pagination */}
                        <Box sx={{ display: "flex", justifyContent: "center", pt: 3 }}>
                            {data && data.length > 0 && (
                                <Pagination color="primary" page={page} count={totalPages} size="small" onChange={(e, p) => setPage(p)} />
                            )}
                        </Box>
                    </Container>
                </Box>
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default HistoryTransfer;
